import { useEmployeeService } from 'domain/shared/employee';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { FormShowTemplate } from 'framework/form';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';
import MenagmentContent from './MenagmentContent';
import { Box } from '@mui/material';
import CareerSectionTitle from '../shared/CareerSectionTitle';

const MenagmenetSection = () => {
  const { updatePeopleManagement, getForUpdate } = useEmployeeService();
  const employeeId = useEmployeeId();

  if (!employeeId) {
    return null;
  }

  const handleSubmit = async (values: FormFieldsData): Promise<void | object> => {
    const managementData = {
      isAccessForAllPeopleManagers: values.isAccessForAllPeopleManagers,
      hasSpecificManagers: values.hasSpecificManagers,
      assignedPeopleManagerAliases: values.assignedPeopleManagerAliases,
    };
    return updatePeopleManagement(employeeId, managementData);
  };

  return (
    <Box position="relative">
      <CareerSectionTitle title="People management" />

      <FormShowTemplate
        getDataFunc={() => getForUpdate(employeeId)}
        submitFormFunc={handleSubmit}
        getValidationSchemaFunc={async () => ({
          assignedPeopleManagerAliases: {
            type: 'array',
            required: {
              value: true,
              when: [
                {
                  $isAccessForAllPeopleManagers: {
                    eq: false,
                  },
                },
              ],
            },
          },
        })}
        afterSubmit={{
          message: 'Worker information has been successfully updated.',
        }}
        isSmallLoader
      >
        <MenagmentContent />
      </FormShowTemplate>
    </Box>
  );
};

export default MenagmenetSection;
